import m from "../../geodata/es2015/peruLow";
window.am4geodata_peruLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/peruLow.js
// module id = null
// module chunks = 